export default function DemoGuide({ step, total, title, body, onBack, onNext, onClose }) {
  const last = step >= total - 1;
  return (
    <aside className="demo-guide" aria-live="polite">
      <div className="flex items-start justify-between gap-3">
        <p className="text-xs font-semibold uppercase tracking-wide text-[#64ba30]">
          Te acompaño · {step + 1} de {total}
        </p>
        <button type="button" className="text-xs text-gray-400 hover:text-gray-700" onClick={onClose}>
          Cerrar
        </button>
      </div>
      <h2 className="text-base font-bold text-[#111827] mt-1">{title}</h2>
      <p className="text-sm text-gray-600 mt-1 leading-relaxed">{body}</p>
      <div className="flex gap-2 mt-3">
        <button type="button" className="btn-secondary text-sm" onClick={onBack} disabled={step === 0}>
          Atrás
        </button>
        <button
          type="button"
          className="text-sm font-semibold text-white px-4 py-2 rounded-xl"
          style={{ background: '#64ba30' }}
          onClick={onNext}
        >
          {last ? 'Listo, exploro solo' : 'Siguiente'}
        </button>
      </div>
    </aside>
  );
}
